import React from 'react'

const BackButton = ({ onClick, disabled }) => {
  const onPress = e => {
    e.preventDefault()

    onClick && !disabled && onClick()
  }

  return (
    <a href="#" className="BackButton" onClick={onPress}>
      &larr; Back
    </a>
  )
}

export default BackButton
